/**
 * Header, USP bar, and promo bar auto-hide on scroll.
 *
 * Behaviour:
 *  - Header + announcement/USP bar: hide on scroll down, show on scroll up (all sizes)
 *  - Promo bar: hide on scroll down, show on scroll up (mobile only)
 */
(function () {
    var header = document.querySelector('store-header');
    if (!header) return;

    var MOBILE_BREAKPOINT = 769;

    // Announcement section (contains USP bar)
    var announcementSection = document.querySelector('.shopify-section-group-header-group .announcement');
    if (!announcementSection) {
        var uspBar = document.querySelector('.usp-bar');
        if (uspBar) {
            announcementSection = uspBar.closest('.shopify-section');
        }
    }

    // Promo bar section wrapper (mobile-only hide)
    var promoSection = document.querySelector('.cc-promo-bar');

    var lastScrollY = window.scrollY;
    var ticking = false;
    var scrollThreshold = 5;
    var hideAfter = 250;

    function isMobile() {
        return window.innerWidth < MOBILE_BREAKPOINT;
    }

    function onScroll() {
        if (ticking) return;
        ticking = true;

        requestAnimationFrame(function () {
            var currentScrollY = window.scrollY;
            var delta = currentScrollY - lastScrollY;

            if (delta > scrollThreshold && currentScrollY > hideAfter) {
                // Scrolling DOWN – hide header + USP (mobile only)
                if (isMobile()) {
                    header.classList.add('header--hidden');
                    if (announcementSection) {
                        announcementSection.classList.add('header--hidden');
                    }
                }
                // Hide promo bar on mobile only
                if (promoSection && isMobile()) {
                    promoSection.classList.add('header--hidden');
                }
            } else if (delta < -scrollThreshold) {
                // Scrolling UP – show everything
                header.classList.remove('header--hidden');
                if (announcementSection) {
                    announcementSection.classList.remove('header--hidden');
                }
                if (promoSection) {
                    promoSection.classList.remove('header--hidden');
                }
            }

            lastScrollY = currentScrollY;
            ticking = false;
        });
    }

    window.addEventListener('scroll', onScroll, { passive: true });

    // On resize to desktop, ensure everything is visible
    window.addEventListener('resize', function () {
        if (!isMobile()) {
            header.classList.remove('header--hidden');
            if (announcementSection) {
                announcementSection.classList.remove('header--hidden');
            }
            if (promoSection) {
                promoSection.classList.remove('header--hidden');
            }
        }
    });
})();
